import React, {useCallback, useContext, useEffect, useMemo} from "react";
import WhiteLogoImage from "../../../assets/icons/ngs-white-blue.svg";
import {useAuth, UserContext} from "../../../context/user";
import {useQuery} from "react-query";

function WhiteLogo() {
    const auth = useAuth();


    const loadImage = useCallback(async () => {




        const base = (process.env.REACT_APP_PLATFORM_API ?? "").replace(/\/?$/, "/")
        const url = `${base}assets/logo/${auth.clientID}?noDefault`
        return await fetch(url).then(async (res) => {
            if (!res.ok) return
            return await res.blob()
        })


    }, [auth.clientID])

    const {data, isLoading} = useQuery(
        ["platform-logo", auth.clientID],
        loadImage,
    )

    const image = useMemo(() => {
        if(data) return URL.createObjectURL(data)
        return WhiteLogoImage
    }, [data])

    const Content = useCallback(() => {
        if (isLoading) return null
        return (
            <img
                src={image}
                alt="logo of the company"
                className="h-fill w-auto max-h-full max-w-[200px] object-contain"
            />
        )

    }, [isLoading, data, image])

    return (
        <div className="w-full h-full flex justify-center items-center">
            <Content/>
        </div>
    );
}

export default WhiteLogo;
